import {LocationsApi} from "@/shared/services";
import {BookingSteps} from "../models";

export const BookingService = {
    checkBookingError(bookingContext, step){
        // check for errors
        if(!bookingContext){
            throw new AppError('No bookingContext');
        }
        if (!bookingContext.availabilityCar || !bookingContext.availabilityCar.id) {
            throw new AppError('No car selected');
        }

        if(step >= BookingSteps.OPTIONS){
        }
        /*
     if(step >= BookingSteps.USER_INFO) {
         if (!bookingContext.user) {
             throw new AppError('No user set');
         }
     }

     if(step >= BookingSteps.PAYMENT) {
         if (!bookingContext.card) {
             throw new AppError('No card set');
         }
     }*/
        if(step === BookingSteps.CONFIRMATION){
            if(bookingContext.number == null){
                throw new AppError('No booking number set');
            }
        }
    }
};
